import {
  DEPOT_ALL_REQUEST,
  DEPOT_ALL_SUCCESS,
  DEPOT_ALL_FAIL,
  DEPOT_ALL_RESET,
  DEPOT_DETAIL_REQUEST,
  DEPOT_DETAIL_SUCCESS,
  DEPOT_DETAIL_FAIL,
  DEPOT_DETAIL_RESET,
  PDF_REQUEST,
  PDF_SUCCESS,
  PDF_FAIL,
  PDFMPS_REQUEST,
  PDFMPS_SUCCESS,
  PDFMPS_FAIL,
  PDF_DOWNLOAD_REQUEST,
  PDF_DOWNLOAD_SUCCESS,
  PDF_DOWNLOAD_FAIL,
  PDF_DOWNLOAD_RESET,
} from "../constants/depot_constant";

import axios from "axios";
import { BASE_URL } from "../axios/serverURL";
export const listDepot = (id_patient) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEPOT_ALL_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactPatient",
      action: "get_total_patient",
      id_patient: id_patient,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    dispatch({
      type: DEPOT_ALL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DEPOT_ALL_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const getpdf = (id_depot) => async (dispatch, getState) => {
  try {
    dispatch({ type: PDF_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactPatient",
      action: "reactPdf",
      id_depot: id_depot,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    dispatch({
      type: PDF_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PDF_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const getpdfMPS = (id_depot) => async (dispatch, getState) => {
  try {
    dispatch({ type: PDFMPS_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactPatient",
      action: "reactPdf",
      id_depot: id_depot,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    dispatch({
      type: PDFMPS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PDFMPS_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
// download pdf
export const telechargerPDF = (id_depot) => async (dispatch, getState) => {
  console.log("id  deppot", id_depot);
  try {
    dispatch({ type: PDF_DOWNLOAD_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactPatient",
      action: "printPdf",
      id_depot: id_depot,
    };

    const { data } = await axios.post(BASE_URL, inputs);
    console.log("action print pdf");

    dispatch({
      type: PDF_DOWNLOAD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PDF_DOWNLOAD_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
